import { render, staticRenderFns } from "./AuditsBanner.vue?vue&type=template&id=93afadaa&"
import script from "./AuditsBanner.vue?vue&type=script&lang=ts&"
export * from "./AuditsBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports